<template>
  <div>
    <div class="defaultBox">
      <div class="left">
        <div class="title">{{ nickname }}</div>
        <div class="profilePhoto">
          <img :src="profilePhoto" alt="" />
        </div>
        <div class="item">
          <div class="subTitle">开始答题时间</div>
          <div class="text">{{ new Date(addTime).toLocaleString() }}</div>
        </div>
        <div class="item">
          <div class="subTitle">答题结束时间</div>
          <div class="text">{{ new Date(endTime).toLocaleString() }}</div>
        </div>
        <div class="item">
          <div class="subTitle">答题时长</div>
          <div class="text">{{ useTimeText }}</div>
        </div>
      </div>
      <div class="right">
        <div
          v-for="(item, index) in defaultDataSubject"
          :key="index"
          @click.stop=""
        >
          <div class="item" v-if="item.type == QuestionType.SCQ">
            <QuestionPreviewSCQ
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewSCQ>
          </div>
          <div class="item" v-if="item.type == QuestionType.MCQ">
            <QuestionPreviewMCQ
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewMCQ>
          </div>
          <div class="item" v-if="item.type == QuestionType.SBQ">
            <QuestionPreviewSBQ
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewSBQ>
          </div>
          <div class="item" v-if="item.type == QuestionType.MBQ">
            <QuestionPreviewMBQ
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewMBQ>
          </div>
          <div class="item" v-if="item.type == QuestionType.DLQ">
            <QuestionPreviewDLQ
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewDLQ>
          </div>
          <div class="item" v-if="item.type == QuestionType.NPS">
            <QuestionPreviewNPS
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewNPS>
          </div>
          <div class="item" v-if="item.type == QuestionType.QA">
            <QuestionPreviewQA
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewQA>
          </div>
          <div class="item" v-if="item.type == QuestionType.SRQ">
            <QuestionPreviewSRQ
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewSRQ>
          </div>
          <div class="item" v-if="item.type == QuestionType.VOTE">
            <QuestionPreviewVote
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewVote>
          </div>
          <div class="item" v-if="item.type == QuestionType.SORT">
            <QuestionPreviewSort
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewSort>
          </div>
          <div class="item" v-if="item.type == QuestionType.SCORE">
            <QuestionPreviewScore
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewScore>
          </div>
          <div class="item" v-if="item.type == QuestionType.WRQ">
            <QuestionPreviewWRQ
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewWRQ>
          </div>
          <div class="item" v-if="item.type == QuestionType.REMARK">
            <QuestionPreviewRemark
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewRemark>
          </div>
          <div class="item" v-if="item.type == QuestionType.NAME">
            <QuestionPreviewName
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewName>
          </div>
          <div class="item" v-if="item.type == QuestionType.GENDER">
            <QuestionPreviewGender
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewGender>
          </div>
          <div class="item" v-if="item.type == QuestionType.AGE">
            <QuestionPreviewAge
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewAge>
          </div>
          <div class="item" v-if="item.type == QuestionType.TEL">
            <QuestionPreviewTel
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewTel>
          </div>
          <div class="item" v-if="item.type == QuestionType.EMAIL">
            <QuestionPreviewEmail
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewEmail>
          </div>
          <div class="item" v-if="item.type == QuestionType.DATE">
            <QuestionPreviewDate
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewDate>
          </div>
          <div class="item" v-if="item.type == QuestionType.TIME">
            <QuestionPreviewTime
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewTime>
          </div>
          <div class="item" v-if="item.type == QuestionType.ADDR">
            <QuestionPreviewAddress
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewAddress>
          </div>
		  <div class="item" v-if="item.type == QuestionType.TFQ">
		    <ExamPreviewTFQ
		      :params="{
		        data: item,
		        answer: defaultDataAnswer[index],
		        index: index,
		      }"
		    ></ExamPreviewTFQ>
		  </div>
		  <div class="item" v-if="item.type == QuestionType.ClozeTest">
		    <ExamPreviewClozeTest
		      :params="{
		        data: item,
		        answer: defaultDataAnswer[index],
		        index: index,
		      }"
		    ></ExamPreviewClozeTest>
		  </div>
          <div class="item" v-if="item.type == QuestionType.IMAGE">
            <QuestionPreviewImage
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewImage>
          </div>
          <div
            class="item"
            v-if="item.type == QuestionType.MaxDiff"
            :class="{ 'max-diff': item.type === QuestionType.MaxDiff }"
          >
            <QuestionPreviewMaxDiff
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewMaxDiff>
          </div>
          <div class="item" v-if="item.type == QuestionType.UploadFile">
            <QuestionPreviewUploadFile
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewUploadFile>
          </div>
          <div class="item" v-if="item.type == QuestionType.DownloadFile">
            <QuestionPreviewDownloadFile
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            >
            </QuestionPreviewDownloadFile>
          </div>
          <div class="item" v-if="item.type == QuestionType.CASCADER">
            <QuestionPreviewCASCADER
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewCASCADER>
          </div>
          <div class="item" v-if="item.type == QuestionType.BDQ">
            <QuestionPreviewBDQ
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewBDQ>
          </div>
          <div class="item" v-if="item.type == QuestionType.IDQ">
            <QuestionPreviewIDQ
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewIDQ>
          </div>
          <div class="item" v-if="item.type == QuestionType.ELQ">
            <QuestionPreviewELQ
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewELQ>
          </div>
          <div class="item" v-if="item.type == QuestionType.WX">
            <QuestionPreviewWX
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewWX>
          </div>
		  <div class="item" v-if="item.type == QuestionType.EvaluationSCQ">
		    <QuestionPreviewSCQ
		      :params="{
		        data: item,
		        answer: defaultDataAnswer[index],
		        index: index,
		      }"
		    ></QuestionPreviewSCQ>
		  </div>
		  <div class="item" v-if="item.type == QuestionType.EvaluationMCQ">
		    <QuestionPreviewMCQ
		      :params="{
		        data: item,
		        answer: defaultDataAnswer[index],
		        index: index,
		      }"
		    ></QuestionPreviewMCQ>
		  </div>
		  <div class="item" v-if="item.type == QuestionType.EvaluationWRQ">
		    <QuestionPreviewWRQ
		      :params="{
		        data: item,
		        answer: defaultDataAnswer[index],
		        index: index,
		      }"
		    ></QuestionPreviewWRQ>
		  </div>
		  <div class="item" v-if="item.type == QuestionType.EvaluationNPS">
		    <QuestionPreviewNPS
		      :params="{
		        data: item,
		        answer: defaultDataAnswer[index],
		        index: index,
		      }"
		    ></QuestionPreviewNPS>
		  </div>
		  <div class="item" v-if="item.type == QuestionType.EvaluationScore">
		    <QuestionPreviewScore
		      :params="{
		        data: item,
		        answer: defaultDataAnswer[index],
		        index: index,
		      }"
		    ></QuestionPreviewScore>
		  </div>
		  <div class="item" v-if="item.type == QuestionType.TextDescription">
		    <EvaluationPreviewDesc
		      :params="{
		        data: item,
		        answer: defaultDataAnswer[index],
		        index: index,
		      }"
		    ></EvaluationPreviewDesc>
		  </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { questionnaireDetail } from "@/api/index.js";
import { QuestionType } from "@/components/constant.js";
import { PreviewComponents } from "@/utils/componentImports.js";

export default {
  components: {
    ...PreviewComponents,
  },
  data() {
    return {
      id: null,
      uuid: null,
      nickname: null,
      addTime: null,
      endTime: null,
      profilePhoto: null,
      useTimeText: null,
      components: [
        {
          type: 1,
          name: "单选",
        },
        {
          type: 2,
          name: "多选",
        },
        {
          type: 3,
          name: "填空",
        },
        {
          type: 4,
          name: "多项填空",
        },
        {
          type: 5,
          name: "下拉",
        },
        {
          type: 6,
          name: "NPS",
        },
        {
          type: 7,
          name: "投票",
        },
        {
          type: 8,
          name: "排序",
        },
        {
          type: 9,
          name: "备注说明",
        },
        {
          type: 10,
          name: "分数评定",
        },
        {
          type: 11,
          name: "问答",
        },
        {
          type: 12,
          name: "权重评分",
        },
        {
          type: 13,
          name: "评星",
        },
        {
          type: 23,
          name: "图片上传",
        },
        {
          type: 24,
          name: "MaxDiff",
        },
        {
          type: 25,
          name: "上传文件",
        },
        {
          type: 26,
          name: "下载附件",
        },
        {
          type: 27,
          name: "联级题",
        },
        {
          type: 14,
          name: "姓名",
        },
        {
          type: 15,
          name: "性别",
        },
        {
          type: 16,
          name: "年龄",
        },
        {
          type: 17,
          name: "电话号",
        },
        {
          type: 18,
          name: "邮箱",
        },
        {
          type: 19,
          name: "日期",
        },
        {
          type: 20,
          name: "时间",
        },
        {
          type: 21,
          name: "地址",
        },
        {
          type: 29,
          name: "出生日期",
        },
        {
          type: 30,
          name: "身份证号",
        },
        {
          type: 31,
          name: "学历",
        },
        {
          type: 32,
          name: "微信号",
        },
      ],
      QuestionType: this.$store.getters["questionType/getQuestionType"],
      defaultDataSubject: [],
      defaultDataAnswer: [],
    };
  },
  created() {},
  mounted() {
    this.id = this.$route.query.id;
    this.uuid = this.$route.query.uuid;
    this.nickname = this.$route.query.nickname;
    this.addTime = Number(this.$route.query.addTime);
    this.endTime = Number(this.$route.query.endTime);
    this.profilePhoto = this.$route.query.profilePhoto;

    const durationMs = this.endTime - this.addTime;
    const seconds = Math.floor(durationMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const remainSeconds = seconds % 60;

    this.useTimeText = `${minutes}分${remainSeconds}秒`;

    this.postData();
  },
  methods: {
    postData() {
      questionnaireDetail({
        answerRecordId: this.id,
        uuid: this.uuid,
      })
        .then((res) => {
          if (res.code === 200) {
            this.defaultDataSubject = res.data.questionList;
            // this.defaultDataAnswer = res.data.answerRecord;
            const answerMap = JSON.parse(res.data.answerRecord || "{}");
            this.defaultDataAnswer = answerMap;
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
  },
};
</script>

<style scoped>
.defaultBox {
  display: flex;
  align-items: flex-start;
  gap: 20px;
}

.defaultBox .left {
  position: relative;
  padding: 0 20px;
  width: 320px;
  background-color: #fff;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.defaultBox .left .title {
  padding: 20px 0;
  font-size: 18px;
  font-weight: bold;
  color: #1e80ff;
  text-align: center;
  border-bottom: 1px solid rgba(241, 243, 247, 1);
}

.defaultBox .left .profilePhoto {
  margin-top: 30px;
  margin-bottom: 20px;
}

.defaultBox .left .profilePhoto img {
  width: 90px;
  height: 90px;
  border-radius: 90px;
}

.defaultBox .left .item {
  width: 100%;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.defaultBox .left .item:last-child {
  margin-bottom: 80px;
}

.defaultBox .left .item .text {
  width: calc(100% - 120px);
  text-align: center;
  word-break: break-all;
}

.defaultBox .right {
  display: flex;
  flex-direction: column;
  width: 790px;
  border-radius: 5px;
  height: calc(100vh - 80px);
  overflow-y: auto;
  gap: 10px;
}

.defaultBox .right::-webkit-scrollbar {
  width: 8px;
}

.defaultBox .right::-webkit-scrollbar-track {
  background: none;
}

.defaultBox .right::-webkit-scrollbar-thumb {
  background: #8b8b8b;
  border-radius: 4px;
}

.defaultBox .right .item {
  position: relative;
}

.defaultBox .right .item::after {
  display: block;
  content: "";
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0);
  position: absolute;
  top: 0;
  left: 0;
}

.defaultBox .right .item.max-diff::after {
  height: 80%;
}
</style>



// WEBPACK FOOTER //
// src/views/DataStatisticsPage/DialogDetail/index.vue